export const fuelTypes = [
  {translationKey: 'diesel', value: 'diesel'},
  {translationKey: 'super_e5', value: 'e5'},
  {translationKey: 'super_e10', value: 'e10'},
];
